.table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.tableHead th {
    padding: 10px 16px;
    text-align: left;
    font-size: 13px;
    font-weight: 600;
    color: var(--exo-color-font-secondary);
    border-bottom: 2px solid var(--exo-color-border-secondary);
    white-space: nowrap;
    user-select: none;
}

.tableHead th:last-child {
    text-align: center;
}

.row {
    border-bottom: 1px solid var(--exo-color-border-secondary);
}

.row:last-child {
    border-bottom: none;
}

.row td {
    padding: 12px 16px;
    vertical-align: middle;
}

.toolNameCell {
    display: flex;
    align-items: center;
    gap: 10px;
}

.connectorIcon {
    width: 28px;
    height: 28px;
    flex-shrink: 0;
    border-radius: 4px;
}

.toolNameInfo {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.toolTitle {
    font-size: 14px;
    font-weight: 500;
    color: var(--exo-color-link);
    cursor: pointer;
}

.toolTitle:hover {
    text-decoration: underline;
}

.toolId {
    font-size: 11px;
    color: var(--exo-color-font-secondary);
}

.toolDescription {
    color: var(--exo-color-font-secondary);
    max-width: 420px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
